import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { FILTER_TENSION, CREATE_TENSION, UPDATE_TENSION, DELETE_TENSION } from 'src/app/graphql/tension.graphql';
import { ErrorLibService } from './error-lib.service';

@Injectable({
  providedIn: 'root'
})
export class TensionService {

  constructor(private apollo: Apollo, private errorLibService: ErrorLibService) { }

  /**
    * Função responsável por filtrar Tensão
    */
  filterTension(company: string | null): any {
    // Faz a requisição
    return this.apollo.watchQuery({
      query: FILTER_TENSION,
      fetchPolicy: 'network-only',
      variables: {
        company
      }
    })
  }

  //------------------ session register tension -------------------------------------------

  /**
    * Função responsavel por criar Tensão
    */
  registerTension(company: string | null, high_tension: number, low_tension: number) {
    // Envia a mutation
    return this.apollo.mutate({
      mutation: CREATE_TENSION,
      variables: {
        company,
        high_tension,
        low_tension
      }
    })
  }

  //------------------ session update tension -----------------------------------------------

  /*
   Método que realiza a alteração de uma tensão no graphql.
  */
  updateTension(company: string | null, high_tension: number, low_tension: number) {
    return this.apollo.mutate({
      mutation: UPDATE_TENSION,
      variables: {
        company,
        high_tension,
        low_tension
      }
    })
  }

  //------------------ session delete tension -----------------------------------------------

  /*
   Método que realiza a alteração de uma tensão no graphql.
  */
  deleteTension(company: string | null) {
    return this.apollo.mutate({
      mutation: DELETE_TENSION,
      variables: {
        company
      }
    })
  }
}
